export const TILE_WIDTH = 14.9; // in pixels
export const TILE_HEIGHT = 65; // in pixels
export const MANIFOLD_HEIGHT = 47; // in pixels

export const DROPZONE_UP = 'dropzoneUp';
export const DROPZONE_DOWN = 'dropzoneDown';
export const DROPZONE_MANIFOLD_UP = 'dropzoneManifoldUp';
export const DROPZONE_MANIFOLD_DOWN = 'dropzoneManifoldDown';

export const BOX_UP = 'boxUp';
export const BOX_MIDDLE = 'boxMiddle';
export const BOX_DOWN = 'boxDown';
